import { gql } from "@outschool/ui-apollo";

import ListingCarousel from "../components/listings/carousels/ListingCarousel";

export const recentlyViewedQuery = gql`
  query RecentlyViewedQuery(
    $skipRating: Boolean!
    $withRecentReviews: Boolean!
    $activityUids: [ID!]!
    $activeLearnerSearchFilters: SearchFilters
  ) {
    featured {
      recentlyViewed(
        activityUids: $activityUids
        activeLearnerSearchFilters: $activeLearnerSearchFilters
      ) {
        ...ListingCarousel_listing
      }
    }
  }
  ${ListingCarousel.fragments.listing}
`;

export const aggregatedUpsellQuery = gql`
  query AggregatedUpsellQuery(
    $skipRating: Boolean!
    $withRecentReviews: Boolean!
    $activeLearnerSearchFilters: SearchFilters
  ) {
    featured {
      aggregatedUpsell(
        activeLearnerSearchFilters: $activeLearnerSearchFilters
      ) {
        ...ListingCarousel_listing
      }
    }
  }
  ${ListingCarousel.fragments.listing}
`;

export const favoriteListingsQuery = gql`
  query FavouriteListings(
    $skipRating: Boolean!
    $withRecentReviews: Boolean!
    $activeLearnerSearchFilters: SearchFilters
  ) {
    featured {
      favoriteListings(
        activeLearnerSearchFilters: $activeLearnerSearchFilters
      ) {
        ...ListingCarousel_listing
      }
    }
  }
  ${ListingCarousel.fragments.listing}
`;

export const startingSoonQuery = gql`
  query StartingSoon(
    $skipRating: Boolean!
    $withRecentReviews: Boolean!
    $activeLearnerSearchFilters: SearchFilters
  ) {
    featured {
      startingSoon(activeLearnerSearchFilters: $activeLearnerSearchFilters) {
        ...ListingCarousel_listing
      }
    }
  }
  ${ListingCarousel.fragments.listing}
`;

export const personalizedRecommendationsQuery = gql`
  query PersonalizedRecommendations(
    $skipRating: Boolean!
    $withRecentReviews: Boolean!
    $activeLearnerUid: ID
  ) {
    featured {
      personalizedRecommendations(activeLearnerUid: $activeLearnerUid) {
        ...ListingCarousel_listing
      }
    }
  }
  ${ListingCarousel.fragments.listing}
`;

export const popularTutorListingsQuery = gql`
  query PopularTutorListings(
    $skipRating: Boolean!
    $withRecentReviews: Boolean!
    $activeLearnerSearchFilters: SearchFilters
  ) {
    featured {
      popularTutorListings(
        activeLearnerSearchFilters: $activeLearnerSearchFilters
      ) {
        ...ListingCarousel_listing
      }
    }
  }
  ${ListingCarousel.fragments.listing}
`;
